import React from 'react'
import { Button } from 'antd'

const qualityDefinitionLabel = 'Definition_of_Tidal_Levels'
const qualityDefinitionLink = 'https://www.metocean-on-demand.com/fileshare/getfile.ashx?type=image&file_name=Definition_of_tidal_levels.png'

export default function TidalLevelAdditionalContent() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '16px',
      height: '100%'
    }}>
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center'
      }}>
        <Button
          type="link"
          href={qualityDefinitionLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontSize: '12px',
            padding: '0',
            height: 'auto',
            textAlign: 'center',
            wordBreak: 'break-word'
          }}
        >
          {qualityDefinitionLabel}
        </Button>
      </div>
    </div>
  )
}
